import classNames from 'classnames'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'
import { Input } from 'core-components/library/inputs'
import { Tooltip } from 'core-components/library/tooltip'

import styles from '../BusinessHours.module.scss'

export const BusinessTime = (props: any) => {
  const [startTime, setStartTime] = React.useState<string>('')
  const [endTime, setEndTime] = React.useState<string>('')
  const [isClosed, setIsCLosed] = React.useState<boolean>(false)
  const [errorString, setError] = React.useState<string | undefined>(undefined)
  const [errorTime, setErrorTime] = React.useState<string | undefined>(undefined)

  React.useEffect(() => {
    const hoursStart = props.startTime.split(':')[0]
    const hoursEnd = props.endTime.split(':')[0]
    hoursStart.length === 1 ? setStartTime(`0${props.startTime}`) : setStartTime(props.startTime)
    hoursEnd.length === 1 ? setEndTime(`0${props.endTime}`) : setEndTime(props.endTime)
    setIsCLosed(props.isClosed)
  }, [])

  const update = (newField: string, newValue: string | boolean) => {
    const obj = {
      isClosed: isClosed,
      from: startTime,
      to: endTime,
      [newField]: newValue,
    }
    props.updateTime(props.index, obj)
  }

  const setTime = (field: string, value: string) =>
    field === 'from' ? setStartTime(value) : setEndTime(value)

  const onChange = (value: string, time: string, field: string) => {
    let valueTime: number | Date = new Date()
    const valueHours = Number(value.split(':')[0])
    const valueMinutes = Number(value.split(':')[1])
    valueTime.setHours(valueHours)
    valueTime.setMinutes(valueMinutes)
    valueTime = valueTime.getTime()
    if (time) {
      let stateTime: number | Date = new Date()
      const hours = Number(time.split(':')[0])
      const minutes = Number(time.split(':')[1])
      stateTime.setHours(hours)
      stateTime.setMinutes(minutes)
      stateTime = stateTime.getTime()
      if (
        (field === 'to' && valueTime > stateTime) ||
        (field === 'from' && valueTime < stateTime)
      ) {
        setError(undefined)
        setErrorTime(undefined)
        setTime(field, value)
        update(field, value)
      } else {
        setError(
          field === 'from'
            ? 'Opening time cannot be later than closing'
            : 'Closing time cannot be earlier than opening'
        )
        setErrorTime(field)
        setTime(field, value)
      }
    } else {
      setError(undefined)
      errorTime && setErrorTime(undefined)
      setTime(field, value)
      update(field, value)
    }
  }

  return (
    <div
      className={classNames(
        styles.businessDay,
        !props.editable ? styles['businessDay--static'] : '',
        props.currentDay === props.index ? styles[`businessDay--current`] : ''
      )}
    >
      {props.editable && (
        <Checkbox
          checked={!isClosed}
          disabled={!props.editable}
          onChange={() => {
            setIsCLosed(!isClosed)
            update('isClosed', !isClosed)
          }}
        />
      )}
      <div className={styles.businessDay__day}>{props.day}</div>
      {(!isClosed && (
        <div className={styles['businessDay__time-wrap']}>
          {errorString && errorTime === 'from' ? (
            <Tooltip tipContent={() => <>{errorString}</>}>
              <Input
                id="time"
                classes={{
                  root: classNames(
                    styles['businessDay__time-item'],
                    !props.editable ? styles['businessDay__time-item--static'] : '',
                    props.currentDay === props.index
                      ? styles[`businessDay__time-item--current`]
                      : '',
                    errorTime === 'from' && styles['businessDay__time-item__error']
                  ),
                }}
                type="text"
                disabled={!props.editable}
                value={startTime}
                onChange={(newValue) => onChange(newValue, endTime, 'from')}
              />
            </Tooltip>
          ) : (
            <Input
              id="time"
              classes={{
                root: classNames(
                  styles['businessDay__time-item'],
                  !props.editable ? styles['businessDay__time-item--static'] : '',
                  props.currentDay === props.index ? styles[`businessDay__time-item--current`] : '',
                  errorTime === 'from' && styles['businessDay__time-item__error']
                ),
              }}
              type="text"
              disabled={!props.editable}
              value={startTime}
              onChange={(newValue) => onChange(newValue, endTime, 'from')}
            />
          )}
          {errorString && errorTime === 'to' ? (
            <Tooltip tipContent={() => <>{errorString}</>}>
              <Input
                id="time"
                classes={{
                  root: classNames(
                    styles['businessDay__time-item'],
                    !props.editable ? styles['businessDay__time-item--static'] : '',
                    props.currentDay === props.index
                      ? styles[`businessDay__time-item--current`]
                      : '',
                    errorTime === 'to' && styles['businessDay__time-item__error']
                  ),
                }}
                disabled={!props.editable}
                type="text"
                value={endTime}
                onChange={(newValue) => onChange(newValue, startTime, 'to')}
              />
            </Tooltip>
          ) : (
            <Input
              id="time"
              classes={{
                root: classNames(
                  styles['businessDay__time-item'],
                  !props.editable ? styles['businessDay__time-item--static'] : '',
                  props.currentDay === props.index ? styles[`businessDay__time-item--current`] : '',
                  errorTime === 'to' && styles['businessDay__time-item__error']
                ),
              }}
              disabled={!props.editable}
              type="text"
              value={endTime}
              onChange={(newValue) => onChange(newValue, startTime, 'to')}
            />
          )}
        </div>
      )) || (
        <div
          className={classNames(styles['businessDay__time-wrap'], styles['businessDay__closed'])}
        >
          <div
            className={classNames(
              styles['businessDay__time-item'],
              styles['businessDay__closed__item'],
              !props.editable ? styles['businessDay__closed__item--static'] : ''
            )}
          >
            <Translation text={'partnerpreview-closed'} />
          </div>
        </div>
      )}
    </div>
  )
}
